import DocumentationMenu from 'Core/components/Navigation/DocumentationMenu';
import FormMenu from 'Core/components/Navigation/FormMenu';
import MyAccessMenu from 'Core/components/Navigation/MyAccessMenu';
import {basename} from 'path';
import React from 'react';
import {connect, useDispatch} from 'react-redux';
import {RouteComponentProps, withRouter} from 'react-router';
import {ReducerState} from 'rootReducer';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';
import {AsyncUserClaims} from 'Users/models/Claims';
import {selectUserScopes} from 'Users/selectors/userProfileSelectors';
import './NavigationMenu.sass';
type NavigationMenuProps = ReturnType<typeof mapStateToProps> & {
  userClaims: AsyncUserClaims;
} & RouteComponentProps;

export const NavigationMenu = (props: NavigationMenuProps) => {
  const {location} = props;
  const {pathname} = location;

  const dispatch = useDispatch();
  const pathTokens = pathname.split('/');

  const basename = pathname.split('/')[1];

  let isAgent;

  const disableNavigation = pathname === '/';

  if (pathTokens.length > 1) {
    const lineOfBusinessPath = pathTokens[1];

    isAgent = lineOfBusinessPath === 'agent' || basename === 'ssoAccounts';
  }

  return (
    <div
      style={{
        padding: disableNavigation ? '0 13.5rem' : '0 3.5rem',
      }}
      className="navigation-menu"
    >
      {!disableNavigation && (
        <>
          {isAgent && (
            <nav>
              <MyAccessMenu {...props} />
              <DocumentationMenu />
              <RequireScope scopes={props.scopes} scope={Scope.AgentResources}>
                <FormMenu />
              </RequireScope>
            </nav>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: ReducerState) => ({
  scopes: selectUserScopes(state),
});

export default withRouter(connect(mapStateToProps)(NavigationMenu));
